import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { SearchX } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <SearchX className="w-12 h-12 text-slate-300 mx-auto mb-4" strokeWidth={1.5} />
        <h1 data-testid="not-found-title" className="font-heading font-black tracking-tighter text-2xl text-slate-900">Página não encontrada</h1>
        <p className="text-sm text-slate-500 mt-2">O endereço que procuras não existe ou foi movido.</p>
        <Button className="rounded-full bg-slate-900 hover:bg-slate-800 mt-8" onClick={() => navigate("/")}>Voltar ao início</Button>
      </div>
    </div>
  );
}
